import TrackingOverview from "../components/TrackingOverview";
import { PageHeader } from "../components/Ui";

/** Agency "Conversions": every client's conversion sync and 30-day return in one table. */
export default function Conversions() {
  return (
    <>
      <PageHeader
        title="Conversions"
      />
      <TrackingOverview />
    </>
  );
}
